import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import ContainerHeader from '../../../components/ContainerHeader/index';

import * as editTemplate from '../../../actions/templatedetails';
import * as regData from '../../../../appConstants'

class EditTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,
            subject: '',
            isSet: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
        // console.log('this.state.customer', this.state.customer);
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSave(event) {
        event.preventDefault();
        // console.log("name", this.state.name)
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            // this.props.actions.fetchTeamDetails(this.state.id);
            this.props.actions.updateTemplateDetails({ "id": this.state.id, "subject": this.state.subject, "template_name": this.state.templateName, "template_content": this.state.templateData, "updatedOn": new Date() });
        }
        // else
        //     this.props.actions.addTeamDetails({ "committee_name": this.state.name });
    };

    componentDidMount() {
        // console.log('componentDidMount', this.state.id)
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            this.props.actions.fetchTemplateDetailsById(this.state.id);
        }
        else {
            this.setState({ id: '' });
            this.setState({ subject: '' });
            this.setState({ templateName: '' });
            this.setState({ templateData: '' });
            this.setState({ updatedOn: new Date() });

        }
        window.addEventListener('load', this.handleLoad);
    }
    handleLoad() {
        $(".tempdata").val('test') //  $ is available here
       }
    render() {

        const { match, templateDetails } = this.props;
        // console.log('teamDetails',teamDetails)
        let result = null;
        if (templateDetails && templateDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (templateDetails && templateDetails.apiGetResult && templateDetails.templatedetails && !this.state.isSet) {
            this.state.id = templateDetails.templatedetails.id;
            this.state.subject = templateDetails.templatedetails.subject;
            this.state.templateName = templateDetails.templatedetails.templateName;
            this.state.templateData = templateDetails.templatedetails.templateData;
            this.state.isSet = true;
            this.setState({ isSet: true });
            this.handleLoad()
        }
        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Edit Template" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSave}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">Template Details</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <label><b>Template Name</b></label>&nbsp; &nbsp;
                                        <label>{this.state.templateName}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" fullWidth
                                                name="subject" label="Template Subject" placeholder="Subject"
                                                validators={['required', regData.regexExp, regData.regexExpLength]}
                                                errorMessages={['This field is required', regData.messageRegexEx, regData.messageLength]}
                                                value={this.state.subject} onChange={this.handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12 tempdata"
                                                name="templateData" label="Template Data"
                                                multiline={true} fullWidth
                                                validators={['required', regData.regexMultiLineExp, regData.regexMultiLineExpLength]}
                                                errorMessages={['This field is required', regData.messageMultilineRegexEx, regData.messageMultilineLength]}
                                                value={this.state.templateData} onChange={this.handleChange} 
                                                InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="col-12">
                                <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={() => { this.props.history.push('/template/template-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {
    // console.log("state==>",state)
    const { templateDetails } = state
    const { match } = ownProps
    return { match, templateDetails, params: ownProps.match.params }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(editTemplate, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditTemplate));



// WEBPACK FOOTER //
// ./app/templatedetails/edittemplate/index.js